import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=8ef94542&"
import script from "./Groups.js?vue&type=script&lang=js&"
export * from "./Groups.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports